import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSingleValueFieldIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2917 5.54167H4.11671C3.22996 5.54167 2.78658 5.54167 2.44789 5.71424C2.14997 5.86604 1.90775 6.10826 1.75595 6.40618C1.58337 6.74488 1.58337 7.18825 1.58337 8.075V10.925C1.58337 11.8117 1.58337 12.2551 1.75595 12.5938C1.90775 12.8917 2.14997 13.134 2.44789 13.2858C2.78658 13.4583 3.22996 13.4583 4.11671 13.4583H10.2917M13.4584 5.54167H14.8834C15.7701 5.54167 16.2135 5.54167 16.5522 5.71424C16.8501 5.86604 17.0923 6.10826 17.2441 6.40618C17.4167 6.74488 17.4167 7.18825 17.4167 8.075V10.925C17.4167 11.8117 17.4167 12.2551 17.2441 12.5938C17.0923 12.8917 16.8501 13.134 16.5522 13.2858C16.2135 13.4583 15.7701 13.4583 14.8834 13.4583H13.4584M13.4584 16.625L13.4584 2.375M15.4375 2.37501L11.4792 2.375M15.4375 16.625L11.4792 16.625",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSingleValueFieldIcon;
